import { IEventListFilters } from '../interfaces';

export function createEventListFilter(formData: any): IEventListFilters {
  const filter: IEventListFilters  = {
    page: formData.pagination ? formData.pagination.page : 1,
    limit: formData.pagination ? formData.pagination.limit : 25,
    filter: formData.filter,
    sort: formData.sort,
    dateFrom: Date.parse(formData.dateFrom) ? new Date(Date.parse(formData.dateFrom)).toDateString() : null,
    dateTo: Date.parse(formData.dateTo) ? new Date(Date.parse(formData.dateTo)).toDateString() : null,
    userId: formData.userName ? formData.userName.id : null,
    entity: formData.entity,
    eventKind: formData.eventKind ? formData.eventKind.id : 0,
  };

  return filter;
}
